import { PropsWithChildren } from "react";

/** Inline code, for use inside tooltips.
 *
 * Typography.Text can't be used here: it renders with an incorrect background
 * and font color against a tooltip's dark backdrop.
 */
export const TooltipCode: React.FC<PropsWithChildren> = ({ children }) => (
  <span className="font-mono text-p0-brand">{children}</span>
);
